// extracted by css-extract-rspack-plugin
export default {"footer":"SessionFooter-module__footer__uEbNi","metadata":"SessionFooter-module__metadata__ZjSRA","separator":"SessionFooter-module__separator__UMywe"};